import type { GridInitialState } from '@packages/fenrir/components/datagrid';

export const getSessionGridState = (key: string): GridInitialState => {
  const stateFromSessionStorage = sessionStorage.getItem(key);

  try {
    const gridState: GridInitialState = stateFromSessionStorage
      ? JSON.parse(stateFromSessionStorage)
      : {};
    return gridState;
  } catch {
    return {};
  }
};
